<template>
  <div @contextmenu="selectComponentDEV($event, schema.model)" :class="['d-flex', getSelectedDEV && 'dev-selected-component']">
    <v-carousel
      :class="['banner-ecm', schema.attributesBanner['animation-hover'] && 'banner-ecm-animation-hover']"
      v-bind="schema.attributesBanner"
      v-model="carouselIndex"
    >
      <v-carousel-item v-for="(ecmDocument, i) in items" :key="i" :class="[ecmDocument.isImage && 'isImage', ecmDocument.isVideo && 'isVideo']">
        <div class="c-slide">
          <v-row :class="['fill-height', 'c-content']">
            <div v-if="ecmDocument.isImage" class="img" :style="backgroundImage(ecmDocument)"></div>

            <vue-plyr class="player-plyr">
              <video v-if="ecmDocument.isVideo" controls width="100%" height="100%" class="player">
                <source :src="ecmDocument.content" :type="ecmDocument.contentType" />
              </video>
            </vue-plyr>
          </v-row>
        </div>
      </v-carousel-item>
    </v-carousel>
  </div>
</template>

<script>
import { abstractField } from 'vue-form-generator';
import devComponentMixin from '@/mixins/dev-component-mixin';
import rulesMixin from '@/mixins/rules-mixin';
import { formatBytes, getIcon } from '@/helpers/utils';
import ECM from '@/services/ecm';

export default {
  mixins: [abstractField, devComponentMixin, rulesMixin],

  data() {
    return {
      items: [],
      carouselIndex: 0
    };
  },

  created() {
    this.getItems();
  },

  watch: {
    carouselIndex(newValue, oldValue) {
      setTimeout(() => {
        const carouselItem = this.$el.querySelectorAll('.v-window__container .v-window-item')[oldValue];
        const isVideo = carouselItem.className.includes('isVideo');

        if (isVideo) {
          const video = carouselItem.querySelector('video');
          video.pause();
        }
      }, 10);
    },

    schema: {
      handler(newValue, oldValue) {
        if (newValue) {
          this.getItems();
        }
      },
      deep: true
    }
  },

  methods: {
    getItems() {
      this.schema.attributes.items.map(async itemEcm => {
        const document = await this.createThumbnail(itemEcm);

        if (document.isImage || document.isVideo) this.items.push(document);
      });
    },

    async createThumbnail(item) {
      const { id_document, nm_key } = item;

      const { data: dataGetDocumentDetail } = await ECM.GetDocumentDetail(this.getHash(id_document, nm_key));
      const { data: dataReturnImageContent } = await ECM.ReturnImageContent(this.getHash(id_document, nm_key));

      const ecmDocument = {
        content: dataReturnImageContent,
        contentType: dataGetDocumentDetail.contentType,
        fileName: dataGetDocumentDetail.fileName,
        isImage: dataGetDocumentDetail.contentType.includes('image/'),
        isVideo: dataGetDocumentDetail.contentType.includes('video/'),
        id: `${dataGetDocumentDetail.documentGroup}-${dataGetDocumentDetail.idDocumentType}`
      };

      return ecmDocument;
    },

    getHash(idDocument, nm_key) {
      let hash = idDocument.toString().padStart(9, '0');
      return `${hash}${nm_key}`;
    },

    backgroundImage(ecmDocument) {
      return `background-image: url(${ecmDocument.content})`;
    }
  }
};
</script>

<style lang="scss">
.banner-ecm {
  .c-slide {
    display: flex;
    justify-content: space-between;
    align-content: center;
    flex-direction: row;
    height: 100%;

    .c-content {
      .img {
        width: 100%;
        height: 100%;
        background-size: 100% 100%;
        background-position-y: center;
      }
    }
  }

  .v-carousel__controls {
    background: rgb(0, 0, 0, 0.1);

    .v-carousel__controls__item {
      color: var(--v-primary-darken2);
    }

    .v-item--active {
      color: var(--v-primary-darken4);
    }
  }

  .player-plyr {
    width: 100%;
    height: 100%;

    .plyr--video {
      height: 100%;
    }
  }

  &.v-carousel {
    overflow: initial;
    margin-bottom: 50px;
  }

  .v-carousel__controls {
    position: initial;
  }
}

.banner-ecm-animation-hover {
  .v-window__prev,
  .v-window__next,
  .v-carousel__controls {
    opacity: 0;
    transition: opacity 1s;
  }

  &:hover {
    .v-window__prev,
    .v-window__next,
    .v-carousel__controls {
      opacity: 1;
    }
  }
}
</style>
